<template>
  <div class="filter-bar">
    <v-flex class="align-self-end filter-select">
      <v-label>Role</v-label>
      <v-select
        :items="roleCategories"
        v-model="role"
        placeholder="All"
        multiple
        class="filter-item"
        hide-default-footer
        dense
        @input="onFilter('group', $event)"
      ></v-select>
    </v-flex>
    <v-flex class="align-self-end filter-select">
      <v-label>Work Location</v-label>
      <v-select
        :items="workLocationCategories"
        v-model="workLocation"
        placeholder="All"
        multiple
        class="filter-item"
        hide-default-footer
        dense
        @input="onFilter('workLocation', $event)"
      ></v-select>
    </v-flex>
    <v-flex class="align-self-end filter-select">
      <v-label>Project Allocation</v-label>
      <v-select
        :items="projectAllocationCategories"
        v-model="projectAllocation"
        placeholder="All"
        multiple
        class="filter-item"
        hide-default-footer
        dense
        @input="onFilter('projectAllocation', $event)"
      ></v-select>
    </v-flex>
    <v-flex class="align-self-end filter-select">
      <v-label>Side Hustle</v-label>
      <v-select
        :items="sideHustleCategories"
        v-model="sideHustle"
        placeholder="All"
        multiple
        class="filter-item"
        hide-default-footer
        dense
        @input="onFilter('sideHustle', $event)"
      ></v-select>
    </v-flex>
    <v-flex class="align-self-end filter-select">
      <v-label>Employment Type</v-label>
      <v-select
        :items="employmentTypeCategories"
        v-model="employmentType"
        placeholder="All"
        multiple
        class="filter-item"
        hide-default-footer
        dense
        @input="onFilter('status', $event)"
      ></v-select>
    </v-flex>
    <v-checkbox
      v-model="showInactive"
      label="Show Inactive"
      class="filter-item-checkbox"
      @change="onChangeInactive()"
    ></v-checkbox>
    <v-btn @click="clearFilters" outlined class="primary--text spacing">Clear Filters</v-btn>
    <add-person></add-person>
  </div>
</template>

<script>
import AddPerson from "./AddPerson.vue";

export default {
  components:{
    "add-person": AddPerson,
  },
  data(){
    return {
        showInactive: false,
        role: [],
        workLocation: [],
        projectAllocation: [],
        sideHustle: [],
        employmentType: [],
    }
  },
  computed: {
    roleCategories(){
      // If the people array is null (such as during load) return an empty array of categories
      if(this.$store.getters.people === null) return [];

      // Extract all categories from the people
      return Object.values(this.$store.getters.people).reduce((acc, person) => {
        if(person.group && !acc.includes(person.group)){
          acc.push(person.group)
        }
        return acc
      }, []);
    },
    workLocationCategories(){
      // Not defined yet in people
      return [];
    },
    projectAllocationCategories(){
      // Not defined yet in people
      return [];
    },
    sideHustleCategories(){
      // Not defined yet in people
      return [];
    },
    employmentTypeCategories(){
      // If the people array is null (such as during load) return an empty array of categories
      if(this.$store.getters.people === null) return [];

      // Extract all categories from the people
      return Object.values(this.$store.getters.people).reduce((acc, person) => {
        if(person.status){
          // TODO - Statuses are not at all uniform. It would probably be better to clean this up in firebase
          let status = person.status.substring(0,1).toUpperCase() + person.status.substring(1).toLowerCase();
          if(!acc.includes(status)){
            acc.push(status);
          }
        }
        return acc;
      }, []);
    }
  },
  methods: {
    onFilter(id, value){
      this.$emit("changeFilter", id, value);
    },
    onChangeInactive(){
      this.$emit("showInactive", this.showInactive);
    },
    clearFilters(){
        this.role = [];
        this.workLocation = [];
        this.projectAllocation = [];
        this.sideHustle = [];
        this.employmentType = [];
        this.showInactive = false;
        this.$emit("changeFilter", "clearAll", null);
        this.$emit("showInactive", false);
    }
  }
}
</script>
<style scoped>
.filter-bar{
  display: flex;
  align-items: center;
}
.filter-item{
  width: 90%
}
.filter-item-checkbox{
  margin-left: 10px;
}
.filter-item + .filter-item{
  margin-left: 10px;
}
.filter-select{
  max-width: 14% !important;
}
.spacing{
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/People/PeopleFilters.vue